import authTypes from 'xm-constants/authenticationTypes';

export const FORM_NAME = 'endpointsModal';

export const hasBaseURLFor = authType => {
  const hiddenFor = [
    authTypes.OAUTH_SLACK,
    authTypes.OAUTH_SLACK_V2,
    authTypes.OAUTH_ZOOM,
    authTypes.OAUTH_ZOOM_S2S,
    authTypes.OAUTH2_GOOGLE,
    authTypes.OAUTH2_MS_GRAPH,
    authTypes.OAUTH2_FORCE,
  ];
  return !hiddenFor.includes(authType);
};

export const showAuthTypeSelector = authType =>
  [authTypes.TOKEN, authTypes.SERVICENOW].includes(authType);
